import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import InfiniteScroll from 'react-infinite-scroller';

import styles from './style.module.scss';

class GridLayout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      padding: 10,
      itemsPerRow: 5
    }

    this.calculateGridSize = this.calculateGridSize.bind(this);
    this.loadMoreItems = this.loadMoreItems.bind(this);
  }

  componentDidMount() {
    this.calculateGridSize();
    window.addEventListener("resize", this.calculateGridSize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.calculateGridSize);
  }

  componentDidUpdate() {
    
  }

  calculateGridSize(){
    var width = this.gridContainer.offsetWidth;

    var item = this.gridContainer.querySelector('.'+styles.item);
    if(item){
      var itemWidth = item.offsetWidth;

      var itemsPerRow = Math.floor(width / itemWidth);
      itemsPerRow = itemsPerRow == 0 ? 1 : itemsPerRow;

      var remainingSpace = width - (itemsPerRow * itemWidth);
      
      if(remainingSpace < 0){
        remainingSpace = 0;
      }

      var padding = remainingSpace / (itemsPerRow - 1);
      if(itemsPerRow == 2){
        var padding = remainingSpace / itemsPerRow;
      }
      
      
      this.setState({
        padding: padding,
        itemsPerRow: itemsPerRow
      })

    }
  }

  loadMoreItems() {
    this.props.loadMore();
  }

  render() {
    const { className } = this.props
    return (
      <div className={cx(className, styles.layout)} 
        ref={(container) => {
          this.gridContainer = container;
        }}>
        { this._renderChildrenItems() }
      </div>
    );
  }

  _renderChildrenItems(){
    let width = (100 / this.props.columns) - 1;
    

    let itemNodes = React.Children.map(this.props.children, (child, index) => {
      let itemElement = React.cloneElement(child);

      var currentColumnIndex = index % this.state.itemsPerRow;
      var endOfRow = currentColumnIndex == this.state.itemsPerRow - 1;

      let style = {
        marginRight: endOfRow ? 0 : this.state.padding
      };

      return (
          <div key={index} className={ cx(styles.item, this.props.itemClass, {[styles.hideItem]: child.type.name === "CreateFolioTile"}) } style={style}>
            { itemElement }
          </div>
      );
    });

    return (
      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={this.props.hasMore}
        loadMore={() => {this.loadMoreItems()}}
        useWindow = {true}
        threshold = {250}
      >
        {itemNodes}
      </InfiniteScroll>
    );
  }

  _renderGapItems(){
    var items = Array();
    for (var i = 0; i < this.props.columns - 2; i++) {
      items.push(<div key={`gap-${i}`} className={ styles.gap }>&nbsp;</div>);
    }

    return items;
  }
}

GridLayout.defaultProps = { 
  columns: 5
};

export default GridLayout;
